import type { PortalPromoDto } from '@supply-mover-2-0/shared';
import type { JSX } from 'react';
import { PromoTile } from './PromoTile';
import type { PromoClickTarget } from './promoClickTarget';

/**
 * Single feature tile. Visually similar to banner but in a smaller
 * grid cell — renders the first selected promo at feature size.
 */
export function PromoOneUpWidget({
	promos,
	density,
	onSelect,
	onLikelyStaleUrl,
}: {
	promos: Array<PortalPromoDto>;
	density?: 'standard' | 'compact';
	/**
	 * Forwarded to each tile. Omit to render tiles inert (CRM
	 * designer preview). See `PromoTile.onSelect`.
	 */
	onSelect?: (target: PromoClickTarget) => void;
	/** Forwarded to each PromoTile. See `PromoTile.onLikelyStaleUrl`. */
	onLikelyStaleUrl?: () => void;
}): JSX.Element | null {
	const promo = promos[0];
	if (promo == null) return null;
	return (
		<div className="w-full h-full">
			<PromoTile
				promo={promo}
				size="feature"
				density={density}
				onSelect={onSelect}
				onLikelyStaleUrl={onLikelyStaleUrl}
			/>
		</div>
	);
}
